module.exports = new __parcel__URL__("zero-content-image.c84ca073.svg").toString();